import { render, staticRenderFns } from "./WorkTypeASelector.vue?vue&type=template&id=94cdd6a8&scoped=true&"
import script from "./WorkTypeASelector.vue?vue&type=script&lang=js&"
export * from "./WorkTypeASelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cdd6a8",
  null
  
)

export default component.exports